export default () => window.__slab.PUBLIC_ORG;
